// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DMI4yUCxNh_QDT9BU2Nu {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 112px 40px 56px;
  background: #1A1D1F;
  opacity: 0;
  animation: nDlr43hprSaM14_njdtF 0.4s forwards;
  overflow: auto;
  z-index: 999;
}
@media only screen and (max-width: 1023px) {
  .DMI4yUCxNh_QDT9BU2Nu {
    padding: 112px 24px 56px;
  }
}
@media only screen and (max-width: 767px) {
  .DMI4yUCxNh_QDT9BU2Nu {
    padding: 148px 16px 32px;
  }
}
.dark-mode .DMI4yUCxNh_QDT9BU2Nu {
  background: #FCFCFC;
}

@keyframes nDlr43hprSaM14_njdtF {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.awnso78nMVGDS_76dMmq {
  max-width: 1124px;
  width: 100%;
  margin: auto;
}

.mM65jA7Crl48QNI53Lvu video {
  width: 100%;
  border-radius: 12px;
}

.ilHV6lCYWB6lxaB7ZJnm {
  overflow: hidden;
  padding: 0 56px;
}
@media only screen and (max-width: 767px) {
  .ilHV6lCYWB6lxaB7ZJnm {
    padding: 0;
  }
}

.NJe87rAJhaBiU53DXBUQ {
  display: flex;
  align-items: center;
  height: 100%;
}
.NJe87rAJhaBiU53DXBUQ img {
  width: 100%;
  border-radius: 16px;
}

.hXjtzkyWVVqlh33XObhD {
  margin-top: 32px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2307692308;
  color: #6F767E;
}
@media only screen and (max-width: 1259px) {
  .hXjtzkyWVVqlh33XObhD {
    margin-top: 24px;
  }
}
@media only screen and (max-width: 767px) {
  .hXjtzkyWVVqlh33XObhD {
    margin-top: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ModalPreview/ModalProduct.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,mBCqCG;EDpCH,UAAA;EACA,6CAAA;EACA,cAAA;EACA,YAAA;AADF;ACAI;EDXJ;IAcI,wBAAA;EACF;AACF;ACFI;EDdJ;IAgBI,wBAAA;EAIF;AACF;ACqKa;EDxKT,mBCqBC;ADfL;;AAJA;EACE;IACE,UAAA;EAOF;EANA;IACE,UAAA;EAQF;AACF;AAPA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AASF;;AANE;EACE,WAAA;EACA,mBAAA;AASJ;;AAPA;EACE,gBAAA;EACA,eAAA;AAUF;AClCI;EDsBJ;IAII,UAAA;EAYF;AACF;;AAXA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAcF;AAbE;EACE,WAAA;EACA,mBAAA;AAeJ;;AAbA;EACE,gBAAA;EACA,kBAAA;ECwDE,eAAA;EACA,gBAAA;EACA,yBAAA;EDxDF,cCZG;AD8BL;AChEI;ED0CJ;IAMI,gBAAA;EAoBF;AACF;AC/DI;EDoCJ;IAQI,gBAAA;EAuBF;AACF","sourcesContent":["@import ../../styles/helpers\n\n.modal\n  display: flex\n  position: fixed\n  top: 0\n  left: 0\n  width: 100%\n  height: 100%\n  padding: 112px 40px 56px\n  background: $n7\n  opacity: 0\n  animation: showModal .4s forwards\n  overflow: auto\n  z-index: 999\n  +t\n    padding: 112px 24px 56px\n  +m\n    padding: 148px 16px 32px\n  +dark\n    background: $n1\n\n@keyframes showModal\n  0%\n    opacity: 0\n  100%\n    opacity: 1\n\n.outer\n  max-width: 1124px\n  width: 100%\n  margin: auto\n\n.video\n  video\n    width: 100%\n    border-radius: 12px\n\n.wrapper\n  overflow: hidden\n  padding: 0 56px\n  +m\n    padding: 0\n\n.preview\n  display: flex\n  align-items: center\n  height: 100%\n  img\n    width: 100%\n    border-radius: 16px\n\n.figcaption\n  margin-top: 32px\n  text-align: center\n  +caption1\n  color: $n4\n  +d\n    margin-top: 24px\n  +m\n    margin-top: 16px","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `DMI4yUCxNh_QDT9BU2Nu`,
	"showModal": `nDlr43hprSaM14_njdtF`,
	"outer": `awnso78nMVGDS_76dMmq`,
	"video": `mM65jA7Crl48QNI53Lvu`,
	"wrapper": `ilHV6lCYWB6lxaB7ZJnm`,
	"preview": `NJe87rAJhaBiU53DXBUQ`,
	"figcaption": `hXjtzkyWVVqlh33XObhD`
};
export default ___CSS_LOADER_EXPORT___;
